import Survey from "../models/SurveyModel";
import { currentUser } from '../common/Utilities';
import { correlatorUser } from '../common/Utilities';
import { getSurveysByArea, getSurveyByID, saveSurvey } from './CorrelatorService';
const { marshall, unmarshall } = require("@aws-sdk/util-dynamodb");

export default class SurveyService  {

    get = async (jobid) => {
      
        const survey = new Promise(function (resolve, reject) {               
        
            getSurveyByID(jobid).then(res => res)
                    .then((data) => {                       
                        //console.log(marshall(data));
                        return resolve((marshall(data)) ? new Survey().fromDb(marshall(data)) : null)
                    })
                .catch((error) => {                  
                    console.error(error);                  
                })     
        });

        return survey;
    };
   

    list = async () => {
          
        const surveyList = new Promise(function (resolve, reject) {
                var user = correlatorUser();
                //console.log(user);
                var surveys = [];
                var selCnt = 0;
                var rtnCnt = 0;
                user.areas.forEach(function (a, idx) {
                    selCnt += 1;
                    getSurveysByArea(a).then(res => res)
                        .then((data) => {
                            rtnCnt += 1;
                            data.forEach(function (s, i) {
                                surveys.push(s);
                            });
                            if (selCnt === rtnCnt) {
                                //console.log(surveys);
                                return resolve(surveys)
                            }
                        })
                        .catch((error) => {
                            rtnCnt += 1;
                            console.error(error);
                            if (selCnt === rtnCnt) {                              
                                return resolve(surveys)
                            }
                        })

                   // }
            });
        });

        return surveyList;
    };

    addTemplates = (survey, templates) => {
        let s = JSON.parse(JSON.stringify(survey));
        let haveChanges = false;
        if (typeof templates !== "undefined") {
            survey.Templates.L.forEach(item => {
                const matchedTemplates = templates.filter((t) => t.value === item.M.Value.S);
                if (matchedTemplates.length > 0) {
                    if (matchedTemplates[0].requiredColumns.length>0) {
                        matchedTemplates[0].requiredColumns.forEach(t => {
                            // See if the column exists, if it doesn't append it
                            if (item.M.Columns.L.filter((c) => {
                                return t.M.ColumnName === c.M.ColumnName;
                            }).length === 0) {
                                item.M.Columns.L.push(JSON.parse(JSON.stringify(t)));
                                haveChanges = true;
                            }
                        });
                    }
                }
            });
        }
        if (haveChanges) {
            s = JSON.parse(JSON.stringify(survey));
        }
        return s;
    };

    // Saves the survey to the server.
    // templates are provided to make sure that required fields exist
    // on the survey.Templates collection.
    put = async (survey, templates) => {
        //console.log(survey);
        if (survey.createdBy == null) {
            survey.createdBy = { S: currentUser() };
        }
        survey.editedBy = { S: currentUser() };
     
        var unmarshalled = unmarshall(survey);
        //console.log(unmarshalled);
        const surveySave = new Promise(function (resolve, reject) {
            saveSurvey(unmarshalled).then(res => res)
                .then((data) => {
                    var saveLbl = document.getElementById("saveLbl");
                    if (saveLbl != null && saveLbl.classList != null) {
                        saveLbl.classList.remove("saveHide");
                        var timer = setInterval(function () {
                            if (saveLbl != null && saveLbl.classList != null) {
                                saveLbl.classList.add("saveHide");
                            }
                        }, 5000);
                    }
                    return true
                })
                .catch(console.log)

        });

        return surveySave;

    //    try {
    //        //const result = await this.db.putItem(params).promise();
    //        // console.log(result);
    //        await this.db.putItem(params).promise();
    //        //alert();
    //        document.getElementById("saveLbl").classList.remove("saveHide");
    //        var timer = setInterval(function () {
    //            document.getElementById("saveLbl").classList.add("saveHide");
    //        }, 4000);            
    //        return true;
    //    } catch (e) {
    //        alert("Unable to save survey")
    //        console.log("Caught an exception from putItem");
    //        console.log(e);
    //        return false;
    //    }
    };
}